module.exports = __webpack_public_path__ + "img/30.27bea847.jpg";